<template>
  <yxtf-breadcrumb>
    <yxtf-breadcrumb-item @click.native="goUrl(item, index)" v-for="(item, index) of list" :key="index" :is-link='true'>{{ item.name }}</yxtf-breadcrumb-item>
  </yxtf-breadcrumb>
</template>

<script>
import { FrontBreadcrumb, FrontBreadcrumbItem } from 'yxt-pc';
export default {
  name: 'YxtbizBreadcrumb',
  components: {
    YxtfBreadcrumb: FrontBreadcrumb,
    YxtfBreadcrumbItem: FrontBreadcrumbItem
  },
  props: {
    defaultMenu: {
      type: Array,
      default() {
        return [];
      }
    },
    value: {
      type: String,
      default: ''
    },
    static: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      breadQuery: ''
    };
  },
  computed: {
    userDefault() {
      return this.static || !this.breadQuery || this.breadQuery === '[]';
    },
    list() {
      if (this.userDefault) {
        if (this.defaultMenu.length === 0) {
          return [{
            name: this.value,
            url: window.location.href
          }];
        }
        return this.defaultMenu;
      }
      try {
        let list = JSON.parse(this.breadQuery);
        if (list && list.length > 0) {
          const index = list.findIndex(nav => nav.name === this.value);
          if (index > -1) return list.splice(0, index + 1); // 进入循环，截取
          list.push({
            name: this.value,
            url: window.location.href
          });
          return list;
        }

        return this.defaultMenu;
      } catch (e) {
        return this.defaultMenu;
      }
    }
  },
  watch: {
    '$route': 'breadConfig',
    'value': 'breadConfig'
  },
  created() {
    this.breadConfig();
  },
  methods: {
    getBread() {
      const bread = sessionStorage.getItem('breadmenu');
      if (bread) {
        this.breadQuery = bread;
      } else {
        this.breadQuery = '';
      }
    },
    setBread() {
      sessionStorage.setItem('breadmenu', JSON.stringify(this.list));
    },
    breadConfig() {
      this.getBread();
      this.setBread();
    },
    goUrl(item, index) {
      if (item.url) {
        window.location.href = item.url;
      }
    }
  }
};
</script>
